import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TmdbAttribution() {
    return (_jsxs("div", { style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
        }, children: [_jsx("a", { href: "https://www.themoviedb.org", target: "_blank", rel: "noopener noreferrer", style: { display: 'inline-flex', flexShrink: 0, opacity: 0.5 }, "aria-label": "The Movie Database", children: _jsx("img", { src: "/images/tmdb-blue-short.svg", alt: "TMDB", style: { height: '10px', display: 'block' } }) }), _jsx("span", { style: {
                    fontSize: '0.625rem',
                    color: 'var(--color-text-faint)',
                    fontFamily: 'var(--font-family-body)',
                }, children: "This product uses the TMDB API but is not endorsed or certified by TMDB." })] }));
}
